/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EntityHintLevel } from './entityHintLevel';

export interface EntityHint {
  level: EntityHintLevel;
  entity_id: string;
}
